module.exports = __webpack_public_path__ + "officialStatic/img/small6.dae6a5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/wireless/small6.png
// module id = P42U
// module chunks = 0